module.exports = __webpack_public_path__ + "media/images/hero_images/about-3000-de23004bc2dbf9b03c2a892099701288.jpg";